export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14773.6e8617b0.jpg";